import Vue from 'vue'
import VueToasted from 'vue-toasted'

Vue.use(VueToasted, {
  iconPack: 'mdi', // Icon pack type to be used ['material', 'fontawesome', 'mdi', 'custom-class', 'callback']
  position: 'bottom-left', // Position of the toast container ['top-right', 'top-center', 'top-left', 'bottom-right', 'bottom-center', 'bottom-left']
})
